import { render } from "./PdfReport.vue?vue&type=template&id=6571df71&scoped=true"
import script from "./PdfReport.vue?vue&type=script&lang=js"
export * from "./PdfReport.vue?vue&type=script&lang=js"

import "./PdfReport.vue?vue&type=style&index=0&id=6571df71&scoped=true&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6571df71"]])

export default __exports__